'use client';

import { Fragment } from 'react';
import DailyBonus from '@/components/entities/dailyBonus';
import { GameCategoryRender } from '@/components/entities/games/GameCategoryRender/GameCategoryRender';
import { useGroupCategories } from '@/hooks/useGroupCategories';
import LobbyOtherCategories from '../LobbyOtherCategories';
import LobbyProviders from '../LobbyProviders';
import FavoritesSlider from './components/FavoritesSlider';
import InfoBanner from './components/InfoBanner';

const CasinoCategories = () => {
  const { beforeFavoritesCategories, afterFavoritesCategories, otherCategories, moreCategories } = useGroupCategories();

  const totalMainCategories = (beforeFavoritesCategories?.length ?? 0) + (afterFavoritesCategories?.length ?? 0);

  return (
    <div id="slots" className="scroll-mt-18">
      <LobbyProviders />

      {beforeFavoritesCategories?.map((category, index) => (
        <GameCategoryRender
          key={category.id}
          categoryName={category.name}
          categoryId={category.id}
          priority={[0, 1].includes(index)}
        />
      ))}
      <FavoritesSlider />
      {totalMainCategories > 0 && totalMainCategories < 3 && <InfoBanner />}
      {afterFavoritesCategories?.map((category, index) => (
        <Fragment key={category.id}>
          <GameCategoryRender
            categoryName={category.name}
            categoryId={category.id}
          />
          {index === 0 && (
            <div className="md:hidden -mt-px mb-5.25">
              <DailyBonus classNameCards="gap-x-1.5" />
            </div>
          )}
        </Fragment>
      ))}
      <LobbyOtherCategories moreCategories={moreCategories ?? []} />
      {otherCategories?.map((category, index) => (
        <Fragment key={category.id}>
          <GameCategoryRender
            key={category.id}
            categoryName={category.name}
            categoryId={category.id}
          />

          {index === 2 && <InfoBanner />}
        </Fragment>
      ))}
    </div>
  );
};

export default CasinoCategories;
